<template>
  <div>
    <bread-crumb></bread-crumb>
    <manFormList
      :select="select"
      :selectList="selectList"
      :isBtn="isBtn"
      @empty="empty"
      @getChangeValue="getChangeValue"
    ></manFormList>
    <div class="box-table">
      <div class="tools">
        <div></div>
        <el-row>
          <el-button type="primary" @click="onMultiImport">批量导入</el-button>
        </el-row>
      </div>
      <el-table :data="tableList" style="width: 100%" ref="multipleTable">
        <el-table-column prop="identityId" label="医生ID"> </el-table-column>
        <el-table-column prop="pin" label="医生PIN"> </el-table-column>
        <el-table-column prop="name" label="医生名称"> </el-table-column>
        <el-table-column prop="autoReplyContentList" label="自动回复内容">
          <template slot-scope="scope">
            <div
              class="commits"
              v-for="(item, index) in scope.row.autoReplyContentList"
              v-html="item"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTimeStr">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                size="small"
                slot="reference"
                @click="handleEditor(scope.row)"
                >编辑</el-button
              >
              <el-popconfirm
                title="确定要删除吗？"
                class="toolsItem"
                @confirm="handleClick(scope.row, 'delete')"
              >
                <el-button type="text" size="small" slot="reference"
                  >删除</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <!-- 弹框-删除 -->
    <!-- 批量导入弹窗 -->
    <el-dialog title="批量导入" :visible.sync="dialogMultiImport" width="400px">
      <div v-if="dialogMultiImport">
        <input
          type="file"
          @change="fileChange"
          ref="file"
          style="margin-bottom: 20px"
        />
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="uploadCategoryExl"
        >
          {{ uploadShow ? "上传中" : "上传" }}
        </el-button>
        <el-button size="medium" @click="downloadCategoryExl">
          下载最新模板
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑信息" :visible.sync="dialogFormVisible">
      <el-form :model="form" :label-width="formLabelWidth" ref="form">
        <el-form-item label="用户ID">
          <el-input
            v-model="form.identityId"
            :disabled="true"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户PIN" :label-width="formLabelWidth">
          <el-input
            v-model="form.pin"
            :disabled="true"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称" :label-width="formLabelWidth">
          <el-input
            v-model="form.name"
            :disabled="true"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in form.autoReplyContentList"
          :label="'自动回复内容' + (index + 1)"
          :label-width="formLabelWidth"
          :key="index"
          :prop="'autoReplyContentList.' + index + '.value'"
          :rules="[
            {
              validator: validate,
              message: '请输入30个以内的中英文字符',
              trigger: 'blur',
            },
          ]"
        >
          <div><el-input v-model="item.value" style="width: 400px" /></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editorRelpy()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "../../../../utils/index.js";
import baseTable from "../../../../components/baseTable";
import manFormList from "../../components/manFormList";
import breadCrumb from "../../../../components/breadCrumb";
import modal from "@/components/modal";
import pagination from "../../../../components/pagination";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../components/importExportCommon.js";
import { mapState } from "vuex";
import {
  health_cmp_pageCommentAutoReplyConfig,
  passCommentInfo,
  rejectCommentInfo,
  health_cmp_deleteCommentAutoReplyConfig,
  addCommentInfoTopStatus,
  cancelCommentInfoTopStatus,
  getImportTemplate,
  health_cmp_upsertCommentAutoReplyConfig,
  health_cmp_queryCommentSourceFilter,
} from "@/api/man";
export default {
  data() {
    return {
      validate: (rule, value, callback) => {
        if (value === "") {
          return callback();
        }
        const regex = /^[\u4e00-\u9fa5a-zA-Z]{0,30}$/;
        if (!regex.test(value)) {
          callback(new Error("只能输入中文或英文，且长度小于等于30个字符"));
        } else {
          callback();
        }
      },
      form: {
        pin: "",
        identityId: "",
        tenantId: 290,
        autoReplyContentList: [],
        type: 1,
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      activeName: "all",
      dialogSetCircle: false,
      dialogVisible: false,
      // 判断环境
      isUrl: "https://hlc.m.jd.com/doctorArticle/?editable=false&id=",
      // 弹框
      isShowDialog: false,
      dialogTitle: "删除",
      isShowBtn: [true, true],
      btnText: ["取消", "删除"],
      dialogText: "是否确认删除",
      dialogType: "",
      ruleForm: {
        desc: "",
      },
      // form 表单绑定参数
      selectList: {
        identityId: "", // 申请时间
        name: "", // 审核状态
      },
      tenantid: null,
      isBtn: 1,
      select: [
        {
          prop: "identityId",
          type: "input",
          placeholder: "ID",
        },
      ],
      // table表格
      tableList: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableListValue: {},
      seletedListIds: "",
      // 全局常量
      commentSourceMap: [],

      dialogMultiImport: false,
      fileName: null,
      uploadShow: false,
    };
  },
  components: {
    baseTable,
    manFormList,
    breadCrumb,
    modal,
    pagination,
  },

  async created() {
    this.tenantid = Number(this.$commonJs.getTenantId());
    // this.getAllInfo();
    this.pageManCommentInfos();
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    async editorRelpy() {
      this.$refs.form.validate(async (valid) => {
        console.log(valid);
        if (valid) {
          health_cmp_upsertCommentAutoReplyConfig({
            ...this.form,
            autoReplyContentList: this.form.autoReplyContentList
              .map((item, index) => {
                return item.value;
              })
              .splice(0, 3),
          })
            .catch((e) => {
              this.$message.show(e.msg);
            })
            .then((ret) => {
              this.getChangeValue();
            });

          this.dialogFormVisible = false;
        } else {
          this.$message.error(
            `自动回复内容只能输入中文或英文，且长度小于等于30个字符`
          );
          return false;
        }
      });
    },
    handleEditor(val) {
      console.log(val);
      // Check if the array property exists, and create it if it doesn't
      if (!val.hasOwnProperty("autoReplyContentList")) {
        val.autoReplyContentList = [];
      }

      const newAutoReplyContentList = val.autoReplyContentList.map(
        (item, index) => {
          return {
            value: item,
          };
        }
      );

      // const filledItems = val.autoReplyContentList.filter(item => Object.keys(item).length > 0);
      while (newAutoReplyContentList.length < 3) {
        newAutoReplyContentList.push({
          value: "",
        });
      }
      this.form = {
        ...val,
        autoReplyContentList: newAutoReplyContentList,
      };
      this.dialogFormVisible = true;
    },
    uploadCategoryExl() {
      uploadCategoryExl(this, 18);
    },
    downloadCategoryExl() {
      getImportTemplate({
        importExportCode: 18,
      }).then((res) => {
        if (res.templateUrl) {
          const excelUrl = res.templateUrl.replace(
            "http://storage.jd.local",
            "https://storage.360buyimg.com"
          );
          window.location.href = excelUrl;
          this.$message.success(`下载成功`);
        }
      });
      // window.location.href = 'https://storage.360buyimg.com/cms-bucket/importExcel/template/null_%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E5%8C%BB%E7%94%9F%E8%87%AA%E5%8A%A8%E5%9B%9E%E5%A4%8D.xlsx?Expires=3882499227&AccessKey=Jd9HhkNEAtwojp2B&Signature=wDb6PRNKENcGaD87EjH6EnIeHUE%3D';
    },
    // 上传文件校验
    async fileChange(e) {
      fileChange(e, this, 5);
    },
    onMultiImport() {
      console.log("==== onMultiImport");
      this.dialogMultiImport = true;
      this.fileName = null;
    },
    // table-按钮
    handleClick(data, type) {
      this.dialogType = type;
      // this.isShowDialog = true
      this.tableListValue = data;
      this.ClickHandler(type, data);
    },
    // 查询
    getChangeValue() {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      this.pageManCommentInfos();
    },
    // 重置
    empty(list) {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      Object.keys(this.selectList).map((item) => {
        console.log(this.selectList[item]);
        if (item == "commentSources") {
          this.selectList[item] = [];
        } else {
          this.selectList[item] = "";
        }
      });
      this.pageManCommentInfos();
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageManCommentInfos();
    },
    // 弹框操作按钮
    ClickHandler(val, data) {
      if (val === "one") {
        this.isShowDialog = false;
      } else {
        switch (this.dialogType) {
          // 删除
          case "delete":
            this.deleteManCommentInfo(data);
            return;
          default:
            this.isShowDialog = false;
            return;
        }
      }
    },
    // 分页请求
    pageManCommentInfos() {
      let data = {
        tenantId: Number(this.$commonJs.getTenantId()),
        type: 1,
        identityId: this.selectList.identityId || undefined,
        name: this.selectList.name || undefined,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      };
      health_cmp_pageCommentAutoReplyConfig(data).then((res) => {
        // console.log(res.data);
        this.tableList.splice(0, this.tableList.length);
        res.data.map((item) => {
          if (item.commentSources) {
            item.commentSources = this.commentSourceMap[item.commentSources];
          }
          this.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
      });
    },
    // 删除
    deleteManCommentInfo(val) {
      console.log(val);
      let data = {
        tenantId: this.$commonJs.getTenantId(),
        identityId: this.tableListValue.identityId,
        ...val,
      };
      health_cmp_deleteCommentAutoReplyConfig(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error("操作失败");
        }
        this.deleteDialog = false;
        this.isShowDialog = false;
        this.pageManCommentInfos();
      });
    },
  },
  filters: {
    auditStatus(data) {
      switch (data) {
        case 1:
          return "待审核";
        case 2:
          return "审核通过";
        case 3:
          return "驳回";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding-top: 10px;
  padding-right: 20px;
}

.box-table {
  background-color: #fff;
}

.tools {
  padding-top: 15px;
  padding-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  :deep(.el-tabs .el-tabs__header) {
    margin-bottom: 0;
  }
  :deep(.el-tabs .el-tabs__content) {
    padding-bottom: 0;
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.border {
  margin: 0 5px 0;
  display: inline-block;
  height: 8px;
  width: 1px;
  /* background-color: black; */
  border: 0.9px solid #266cee;
}

.box_text {
  width: 100%;
  text-align: center;
  padding-top: 20px;
  font-size: 16px;
}

.Url {
  color: #266cee;
  cursor: pointer;
}

:deep(.commits) {
  em {
    color: red;
  }
}

.toolsItem {
  margin: 0 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
</style>
